const getBreadcrumbLinks = () => {
  const url = typeof window !== 'undefined' ? window.location.pathname : '';

  const defaultLinks = ['/'];

  if (!url) {
    return defaultLinks;
  }

  const matches = url.match(/[^/]+/g);

  const links =
    matches &&
    matches.reduce((acc, curr, index) => {
      const link = index === 0 ? `/${curr}` : `${acc[index - 1]}/${curr}`;

      return [...acc, link];
    }, []);

  return links || defaultLinks;
};

export default getBreadcrumbLinks;
